module.exports = __webpack_public_path__ + "static/media/plan-D3b-mobile-en.958f240b.png";